<template>
  <v-layout
    align-content-center
    justify-start
    row
    wrap
  >
    <v-flex v-if="items.length > 0">
      <template v-for="(item, index) in items">
        <v-checkbox
          v-if="hideElement !== item.support_criterion_id"
          :key="index"
          v-model="checkboxModel"
          :hide-details="true"
          :label="item.name"
          :value="item"
          :multiple="multiselect"
          class="sz-chips"
          :disabled="disableCheckbox(item) || disabled"
          :error="errorMessages.length > 0"
          @click="emitModel()"
        >
          {{ item.name }}
        </v-checkbox>
      </template>
    </v-flex>
    <v-flex
      v-else
      xs12
    >
      <v-progress-linear
        height="5"
        color="sz_violet"
        indeterminate
      />
    </v-flex>
    <v-flex
      xs12
      mt-1
    >
      <div class="v-messages theme--light error--text">
        <div class="v-messages__wrapper">
          <div
            v-for="(error, index) in errorMessages"
            :key="index"
            class="v-messages__message"
          >
            {{ error }}
          </div>
        </div>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
    name: 'SelectableList',
    props: {
        items: {
            type: Array,
            required: true
        },
        value: {},
        exclusionElem: {
            required: false,
            default: false
        },
        multiselect: {
            required: false,
            default: true,
            type: Boolean
        },
        hideElement: {
            required: false,
            default: false
        },
        'error-messages': {
            default: () => {
                return [];
            }
        },
        disabled: {
            default: false,
            type: Boolean
        }
    },
    data () {
        return {
            checkboxModel: [],
            disable: false
        };
    },
    watch: {
        value (newValue) {
            this.checkNewValue(this.exclusionElem, newValue);
        }
    },
    created () {
        this.checkNewValue(this.exclusionElem, this.value);
    },
    methods: {
        emitModel () {
            this.checkNewValue(this.exclusionElem, this.checkboxModel);
            this.$emit('input', this.checkboxModel);
        },
        checkNewValue (elem, arr) {
            if (elem) {
                let _includeElem = false;
                let _elemObj = {};
                for (let i = 0; i < arr.length; i++) {
                    _includeElem = this.findElemInObject(arr[i], elem);
                    if (_includeElem) {
                        _elemObj = arr[i];
                        break;
                    }
                }
                if (_includeElem) {
                    this.disable = true;
                    this.checkboxModel = [_elemObj];
                } else {
                    this.disable = false;
                    this.checkboxModel = arr;
                }
            } else {
                this.checkboxModel = arr;
            }
        },
        findElemInObject (obj, elem) {
            let _isThisId = false;
            for (const key in obj) {
                if (obj[key] === elem) {
                    _isThisId = true;
                }
            }
            return _isThisId;
        },
        disableCheckbox (item) {
            if (this.exclusionElem) {
                if (this.disable && !this.findElemInObject(item, this.exclusionElem)) {
                    return true;
                } else {
                    return false;
                }
            }
        }
    }
};
</script>

<style lang="scss"></style>
